import React from 'react';
import PropTypes from 'prop-types';

function ShareButton({ active, activeColor, color }) {
  return (
    <path
      d="M271.405 171.138H264.291C260.231 171.138 256.909 167.816 256.909 163.756V141.633C256.909 137.573 260.231 134.251 264.291 134.251H271.405C275.465 134.251 278.787 137.573 278.787 141.633V163.756C278.787 167.816 275.465 171.138 271.405 171.138Z"
      fill={active ? activeColor : color}
    />
  );
}

ShareButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

ShareButton.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#4F535F',
};

export default ShareButton;
